export const CARGO_ACTIVATION_STATUSES = {
  PENDING: { key: "PENDING", name: "Pending", color: "blue" },
  APPROVED: { key: "APPROVED", name: "Approved", color: "green" },
  REJECTED: { key: "REJECTED", name: "Rejected", color: "red" },
};

export const CARGO_ACTIVATION_REJECT_REMARKS = [
  { remark: "Incomplete or Incorrect Information" },
  { remark: "Supporting Documents Not Provided or Invalid" },
  { remark: "Failure to Meet Eligibility Criteria" },
  { remark: "Others" },
];
